import { FC, ReactNode, useState } from 'react';
import Box from '@o2/ui/Box';
import Container from '@o2/ui/Container';
import IconButton from '@o2/ui/IconButton';
import Link from '@o2/ui/Link';
import Stack from '@o2/ui/Stack';
import TextField from '@o2/ui/TextField';
import Typography from '@o2/ui/Typography';
import CrossIcon from '@o2/icons/Cross';

import { Wireframe, WireframesConfig } from './wfTypes';

type WireframeLink = Pick<Wireframe, 'url' | 'name' | 'id'>;

interface WireframeListPageProps extends WireframesConfig {
  renderLink: (wf: WireframeLink) => ReactNode;
}

const WireframeListPage: FC<WireframeListPageProps> = ({
  projectName,
  wireframes,
  axureUrl,
  figmaUrl,
  renderLink,
  ...other
}) => {
  const [search, setSearch] = useState<string>('');

  return (
    <Container maxWidth="md">
      <Box p={4} {...other}>
        <Box mb={4} textAlign="center">
          <Typography variant="h3">{projectName}</Typography>
        </Box>
        <Box mb={4}>
          <Stack direction={{ xs: 'column-reverse', sm: 'row' }} justifyContent="space-between">
            <TextField
              label="Hledat"
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
              }}
              autoFocus
              autoComplete="off"
              InputProps={{
                endAdornment: (
                  <IconButton sx={{ opacity: 0.4 }} onClick={() => setSearch('')}>
                    <CrossIcon />
                  </IconButton>
                ),
              }}
            />

            {(axureUrl || figmaUrl) && (
              <Box mb={4} textAlign="center">
                <Stack direction="row" spacing={2}>
                  <a href={axureUrl} target="_blank" rel="noreferrer">
                    <Link>Axure</Link>
                  </a>
                  <a href={figmaUrl} target="_blank" rel="noreferrer">
                    <Link>Figma</Link>
                  </a>
                </Stack>
              </Box>
            )}
          </Stack>
        </Box>
        <ul>
          {wireframes
            .filter((wf) => {
              if (wf.nonNavigable) return false;

              if (search === '') return true;

              const id = wf.id.toString().toLowerCase();
              const searchLower = search.toLowerCase();

              return (
                id.includes(searchLower) ||
                wf.name.toLowerCase().includes(searchLower) ||
                wf.url.toLowerCase().includes(searchLower) ||
                wf.navUrl?.toLowerCase().includes(searchLower) ||
                id.includes(searchLower.replace(/-/g, '.'))
              );
            })
            .map((wf) => (
              <li key={wf.id}>
                {renderLink({
                  url: wf.navUrl ?? wf.url,
                  id: wf.id,
                  name: wf.name,
                })}
              </li>
            ))}
        </ul>
      </Box>
    </Container>
  );
};

export default WireframeListPage;
